import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Paginacion } from './Paginacion';
import { MateriasConsulta } from './MateriasConsulta';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

export class Materias extends Component {
    static displayName = Materias.name;

    constructor(props) {
        super(props);
        this.state = { materias: [], page: 1, size: 10, codigo: "", nombre: "", loading: true };
        this.handlePage = this.handlePage.bind(this);
    }

    componentDidMount() {
        document.title = TITLE + " - Histórico por materia";
        const page = parseInt(this.props.match.params["page"]) || this.state.page || 1;
        const size = parseInt(this.props.match.params["size"]) || this.state.size || 10;
        const codigo = this.props.match.params["search1"] || this.state.codigo || "";
        const nombre = this.props.match.params["search2"] || this.state.nombre || "";
        if (this.state.loading) {
            this.populateData(page, size, codigo, nombre);
        }
    }

    componentDidUpdate() {
        const page = parseInt(this.props.match.params["page"]) || this.state.page || 1;
        const size = parseInt(this.props.match.params["size"]) || this.state.size || 10;
        const codigo = this.props.match.params["search1"] || this.state.codigo || "";
        const nombre = this.props.match.params["search2"] || this.state.nombre || "";
        if (this.state.loading) {
            this.populateData(page, size, codigo, nombre);
        }

    }

    handlePage(url, page, size, codigo, nombre) {
        let newUrl = `${url}/${page}/${size}`;

        if (codigo && codigo.trim() !== "") {
            newUrl += `/${encodeURIComponent(codigo.trim())}`;
        }
        if (nombre && nombre.trim() !== "") {
            if (!codigo || codigo.trim() === "") newUrl += `/${encodeURIComponent(" ")}`;
            newUrl += `/${encodeURIComponent(nombre.trim())}`;
        }

        this.props.history.push(newUrl);
        this.setState({ loading: true, page: page, size: size, codigo: codigo, nombre: nombre });
    }

    renderTable(materias) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Materia</th>
                        <th>{''}</th>
                    </tr>
                </thead>
                <tbody>
                    {materias.map(materia =>
                        <tr key={materia.codigo}>
                            <td>{materia.codigo}</td>
                            <td>{materia.materia}</td>
                            <td>
                                <Link className="btn btn-secondary" to={`/paralelos-materia/${materia.codigo}/1/10`}>Detalle</Link>
                            </td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={3}>
                            <Paginacion total={this.state.total} page={this.state.page} size={this.state.size} search1={this.state.codigo} search2={this.state.nombre} url={`/materias`} handle={this.handlePage} />
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }

    render() {
        const page = parseInt(this.props.match.params["page"]) || this.state.page || 1;
        const size = parseInt(this.props.match.params["size"]) || this.state.size || 10;
        const codigo = this.props.match.params["search1"] || this.state.codigo || " ";
        const nombre = this.props.match.params["search2"] || this.state.nombre || " ";

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.materias);

        return (
            <div>
                <h1 id="tabelLabel" >Histórico por materias</h1>
                <br />
                <MateriasConsulta codigo={codigo} nombre={nombre} page={1} size={10} url={`/materias`} handle={this.handlePage} />
                <br />
                {contents}
            </div>
        );
    }

    async populateData(page, size, codigo, nombre) {
        let apiUrl = `${APIURL}/api/reportes/materias/${page}/${size}`;
        if (codigo && codigo.trim() !== "") {
            apiUrl += `/${encodeURIComponent(codigo.trim())}`;
        }
        if (nombre && nombre.trim() !== "") {
            if (!codigo || codigo.trim() === "") apiUrl += `/${encodeURIComponent(" ")}`;
            apiUrl += `/${encodeURIComponent(nombre.trim())}`;
        }

        const response = await fetch(apiUrl);
        const data = await response.json();
        this.setState({ total: data.total, materias: data.datos, page: page, size: size, codigo: codigo, nombre: nombre, loading: false });
    }
}
